import { IInboundEmailCommunication } from 'shared';
import { Tooltip } from '@mui/material';

import { WrappedLink } from '../../WrappedLink';
import { formatInboxDate } from '../common/formatInboxDate';
import { TruncatedTextWithTooltip } from '../common/TruncatedTextWithTooltip';

interface EmailInboxRowProps {
  email: IInboundEmailCommunication;
  onRowClick: (email: IInboundEmailCommunication) => void;
}

export function EmailInboxRow({
  email,
  onRowClick,
}: EmailInboxRowProps) {
  return (
    <tr
      className={ `cursor-pointer hover:bg-gray-50` }
      onClick={ () => onRowClick(email) }
    >
      <td className={ `px-3 py-3 text-sm text-gray-700 whitespace-nowrap` }>{ formatInboxDate(email.createdAt) }</td>
      <td className={ `px-3 py-3 text-sm text-gray-700 whitespace-nowrap` }>
        { email.contactId ? (
          <WrappedLink
            className={ `inline text-blue-600 underline` }
            to={ `/contacts/${email.contactId}` }
            onClick={ e => e.stopPropagation() }
          >
            <Tooltip title={ email.contactName || `Contact #${email.contactId}` }>
              <span className={ `inline-block truncate max-w-[220px] align-bottom` }>
                { email.contactName || `Contact #${email.contactId}` }
              </span>
            </Tooltip>
          </WrappedLink>
        ) : `-` }
      </td>
      <td className={ `px-3 py-3 text-sm text-gray-700 max-w-[240px]` }>
        <TruncatedTextWithTooltip value={ email.forwardedFrom ? `${email.forwardedFrom} (forwarded by ${email.from})` : email.from } />
      </td>
      <td className={ `px-3 py-3 text-sm text-gray-900 max-w-[260px]` }>
        <TruncatedTextWithTooltip value={ email.subject } />
      </td>
      <td className={ `px-3 py-3 text-sm text-gray-700 max-w-[420px]` }>
        <TruncatedTextWithTooltip value={ email.extractedReplyText || email.textBody } />
      </td>
    </tr>
  );
}
